import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import useReduxAction from '@hooks/useReduxAction'

import type { EntityOptions } from '@redux/modules/module'

const entitySettings = {
  agency: {
    module: 'agencies',
    action: 'loadAgency',
  },
  campaign: {
    module: 'campaigns',
    action: 'loadCampaign',
  },
}

interface UseLoadEntityParams {
  entityId: number,
  entityType: 'agency' | 'campaign',
  redirectUrl?: string,
  requestOptions?: EntityOptions,
}

const useLoadEntity = (params: UseLoadEntityParams) => {
  const {
    entityId, entityType, redirectUrl = '/', requestOptions,
  } = params
  const { module, action } = entitySettings[entityType] || {}

  const { success } = useReduxAction(
    // @ts-expect-error TS2345
    module,
    action,
    {
      entityId,
      requestOptions: {
        performHttpRequests: !!entityId,
        ...requestOptions,
      },
    },
    [entityId],
    {
      dispatchAction: (action, actionRequestOptions) => action(entityId, actionRequestOptions),
      skipLoadedForKeysCheck: true,
    },
  )

  // redirect if entity doesn't load
  const navigate = useNavigate()

  useEffect(() => {
    if (success === false){
      navigate(redirectUrl)
    }
  }, [success])
}

export default useLoadEntity
